import Badge from "../components/common/Badge";

const defaultRender = (value) => (value ? value : '--');

const columns = [
    {
        title: 'User',
        dataIndex: 'userDetails',
        render: defaultRender,
    },
    {
        title: 'Mobile No',
        dataIndex: 'phoneNo',
        render: defaultRender,
    },
    {
        title: 'User Type',
        dataIndex: 'userType',
        render: (value) => (
            <Badge text={value} type={value === 'IB' ? "warning" : "secondary"}/>
        ),
    },
    {
        title: 'Parent',
        dataIndex: 'parentName',
        render: defaultRender,
    },
    {
        title: 'Status',
        dataIndex: 'status',
        render: defaultRender,
    },
   
];

export default columns;